import AddressHashWithCopy from './addressHashWithCopy';

export default AddressHashWithCopy;
